import React from "react";
import { invoiceService } from '../services/invoiceService';
import { wmsService } from '../services/wmsService';
import { Card, Button, InputGroup, FormControl, Form, Col, Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import { Redirect } from "react-router-dom";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import cellEditFactory from 'react-bootstrap-table2-editor';

class InvoiceAddLineItem extends React.Component {  
  constructor(props) {
    super(props);
    this.state = {
      serviceid: undefined,

      id: undefined,      
      invoiceId: undefined,
      quoteId: undefined,
      itemId: undefined,
      item: undefined,
      description: undefined,
      qty: undefined,
      listPrice: undefined,
      discount: undefined,
      unitPrice: undefined,
      tax1: undefined,
      tax01: undefined,
      scheduledShipDate: undefined,
      companyId: undefined,
      warehouseloc: undefined,
      
      ////
      edititem: undefined,
      origitem: undefined,
      origItemId: undefined,

      taxOptions:[],
      mouOptions: [],
      gobackto: undefined,
      searchmodal: false,
      invitems: [],
      invcolumns: [
        {
          dataField: 'id',
          text: 'id',
          hidden: true
        },{
          dataField: 'uniqueid',
          text: 'uniqueid',
          hidden: true
        }, {
          dataField: 'item',
          text: 'Item',
          hidden: false,
          sort: true,
          headerStyle: {
            backgroundColor: '#D9D8D9'
          },
          formatter: (cellContent, row) => {
            let config = JSON.parse(localStorage.getItem('config'));
            //console.log(config);
            let st = JSON.parse(config.serviceorderstatuses);
            return (
              <h6><small>
                {row.item &&
                <div className="label label-success">{row.item}</div>
                }
                {row.description &&
                <div className="label label-success">{row.description}</div>
                }                
              </small></h6>
            );            
          }
        }, {
          dataField: 'description',
          text: 'Description',
          hidden: true,
          headerStyle: {
            backgroundColor: '#D9D8D9'
          }
        }, {
          dataField: 'inventory',
          text: 'Quantity',
          hidden: true,
          headerStyle: {
            backgroundColor: '#D9D8D9'
          }
        },{
          dataField: 'discount',
          text: 'Discount',
          hidden: true,
          headerStyle: {
            backgroundColor: '#D9D8D9'
          }
        },{
          dataField: 'unitofmeasure',
          text: 'UoM',
          hidden: true,
          headerStyle: {
            backgroundColor: '#D9D8D9'
          }
        },{
          dataField: 'actualunitcost',
          text: 'Purchased Cost',
          hidden: true,
          headerStyle: {
            backgroundColor: '#D9D8D9'
          }
        }, {
          dataField: 'unitcost',
          text: 'Qty and Unit Price',
          hidden: false,
          headerStyle: {
            backgroundColor: '#D9D8D9'
          },
          formatter: (cellContent, row) => {
            let config = JSON.parse(localStorage.getItem('config'));
            //console.log(config);
            let st = JSON.parse(config.serviceorderstatuses);
            let qt = 0;
            if (row.inventory) {
              qt = row.inventory;
            }
            let up = 0;
            if (row.unitcost) {
              up = Number(row.unitcost).toFixed(2);
            }
            return (
              <h6><small>              
                {
                <div className="label label-success">Qty: {qt} </div>
                }
                {
                <div className="label label-success">Unit Price: {up}</div>
                }
              </small></h6>
            );            
          }
        },        
        {
          dataField: 'location_name',
          text: 'Warehouse',
          sort: true,
          headerStyle: {
            backgroundColor: '#D9D8D9'
          }
        }],
        selectInvRow: {
          mode: 'radio',
          clickToSelect: true,
          hideSelectColumn: true,
          bgColor: '#adb5bd',
          onSelect: (row, isSelect, rowIndex, e) => {
            this.handleSelectedLineItem(row);
          }
        },
        selectedRow: undefined,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);   
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelectItem = this.handleSelectItem.bind(this);
    this.handleSelectItemClose = this.handleSelectItemClose.bind(this);
    this.handleSelectedLineItem = this.handleSelectedLineItem.bind(this);
    this.searchItems = this.searchItems.bind(this);
    this.goBackWithInvoice = this.goBackWithInvoice.bind(this);
  }

  componentDidMount() {  
    
    let usr = JSON.parse(localStorage.getItem('user'));
    if (usr.config.mou) {
      this.setState({mouOptions: usr.config.mou});
    }
    if (usr.config.tax) {
      this.setState({taxOptions: usr.config.tax});
    }

    const { id } = this.props.match.params; //invoiceId
    this.state.invoiceId = id;
    console.log(this.props.match.params, this.state.invoiceId);
  }

  handleInputChange(event) {
    const target = event.target;
    //alert(target.id + ', ' + target.value)
    const name = target.id;
    //alert(name + ', ' + target.value);
    if (name === 'tax01' && target.value === "Choose...") {
      this.setState({tax1: undefined,
                     tax01: undefined})
    }    
    else {
      this.setState({
        [name]: target.value
      });
      if (name === 'tax01') {
        //alert(JSON.stringify(this.state.taxOptions));
        for (let i=0; i<this.state.taxOptions.length; i++) {
          let o = this.state.taxOptions[i];
          if (o["name"] === target.value) {
            //alert(o["rate"]);         
            this.setState({tax1: o["rate"]});         
          }
        }
      } 
    }
  }
  
  handleSubmit(event) {
    event.preventDefault();
    alert('handleSubmit...:');
    let item = {};
    if (this.state.unitPrice) {
      this.state.unitPrice = Number(this.state.unitPrice).toFixed(2);
    }
    
    item.invoiceId = this.state.invoiceId;
    item.itemId = this.state.itemId;
    item.item = this.state.item;
    item.description = this.state.description;
    item.qty = this.state.qty;
    item.listPrice = this.state.listPrice;
    item.discount = this.state.discount;
    item.unitPrice = this.state.unitPrice;
    item.tax1 = this.state.tax1;
    item.tax01 = this.state.tax01;
    item.scheduledShipDate = this.state.scheduledShipDate;
    item.whLocation = this.state.warehouseloc;
    
    invoiceService.addOrUpdateInvLineItem(this.state.invoiceId, item).then(solitm => {
      if (solitm && solitm === 401) {
        this.props.history.push("/login");
      } else {
        //goback...        
        invoiceService.getInv(this.state.invoiceId).then(invoice => {
          if (invoice && invoice === 401) {
            this.props.history.push("/login");
          } else {
            var { from } = this.props.location.state || { from: { pathname: "/InvoiceView" } };  
            this.props.history.push(from, invoice); 
          }
        });
      }
    });
  }

  goBackWithInvoice = () => {
    invoiceService.getInv(this.state.invoiceId).then(invoice => {
      if (invoice && invoice === 401) {
        this.props.history.push("/login");
      } else {
        var { from } = this.props.location.state || { from: { pathname: "/InvoiceView" } };  
        this.props.history.push(from, invoice); 
      }
    });
  }
  // handleDelete(event) {
 
  //   invoiceService.deleteInvItem(this.state.id, this.state.invoiceId).then(solitm => {
  //     if (solitm && solitm === 401) {
  //       var { from } = this.props.location.state || { from: { pathname: "/login" } };  
  //       this.props.history.push(from);
  //     } else if (solitm.id) {
  //       //goback...
  //       this.setState({gobackto: '/ecinvoice/' + this.state.invoiceId + '/serviceid/' + this.state.serviceid});        
  //     }
  //   });
  // }

  handleCancel(event) {
    this.goBackWithInvoice();
  }

  searchItems = () => {
    let user = JSON.parse(localStorage.getItem('user'));
    wmsService.getWmsInventorySearchIcludePrice(this.state.edititem, user.config.inventoryLocation).then(items => {
      if (items && items === 401) {
        this.props.history.push("/login");
      } else {
        console.log(items);
        this.setState({
          invitems: items,
          searchmodal: !this.state.searchmodal});            
      }
    });    
    
  }

  handleSelectItemClose = () => {
    this.setState({searchmodal: !this.state.searchmodal});
  }

  handleSelectItem = () => {
    if (this.state.selectedRow && this.state.selectedRow.id) {
      //alert(JSON.stringify(this.state.selectedRow));
      this.setState({
        item: this.state.selectedRow.item,
        itemId: this.state.selectedRow.id,         
        description: this.state.selectedRow.description,
        qty: this.state.selectedRow.qty,
        listPrice: this.state.selectedRow.actual_unit_cost,
        discount: this.state.selectedRow.discount,
        unitPrice: this.state.selectedRow.unit_cost,
        warehouseloc: this.state.selectedRow.invlocation,
        searchmodal: !this.state.searchmodal,
      });
      //alert(this.state.selectedRow.item + ',' + this.state.edititem + ', ' + this.state.description);
    } else {
      this.setState({        
        searchmodal: !this.state.searchmodal
      });
    }    
  }

  handleSelectedLineItem = (row) => {
    //alert(JSON.stringify(row));
    this.setState({selectedRow: row});
    
    // this.setState({
    //   itemId: row.id,   
    //   item: row.item,
    //   description: row.description,
    //   qty: row.inventory,
    //   listPrice: row.actualUnitCost,
    //   discount: row.discount,
    //   unitPrice: Number(row.unitCost).toFixed(2)
    // });
  }

  render() {

    if (this.state.gobackto) {
      return <Redirect to={this.state.gobackto} />
    }

    let txOpt = [];
    txOpt.push(<option>Choose...</option>);
    if (this.state.taxOptions) {      
      for (let i=0; i<this.state.taxOptions.length; i++) {
        let obj = this.state.taxOptions[i];
        //console.log(obj);
        // txOpt.push(<option key={obj.name} value={obj.name}>{obj.name}</option>);
        if (this.state.tax01 && this.state.tax01 === obj.name) {
          txOpt.push(<option value={obj.name} selected>{obj.name}</option>);
        } else {
          txOpt.push(<option value={obj.name}>{obj.name}</option>);
        }
      }
    }
    
    return (
      <div className="content-screen">    
        <Card style={{ width: '36rem' }}>
          <Card.Header>
            
            <Form>
                  <div style={{width: "70%", display: "inline-block"}}>
                  
                  <Form.Group as={Col} style={{marginBottom: '1px'}} controlId="edititem" onChange={this.handleInputChange}>
                      <InputGroup>
                      <Form.Control placeholder="Search item in inventory" defaultValue={this.state.edititem} />  
                      <InputGroup.Append>
                          <Button onClick={this.searchItems} variant="outline-primary">Search</Button>
                      </InputGroup.Append>
                      </InputGroup>
                  </Form.Group>
                  
                  </div>                                  
            </Form>
            
          </Card.Header>
          <Card.Body>      

              <Form noValidate onSubmit={this.handleSubmit}>
              <Form.Row></Form.Row>
                  {/* <Form.Row>
                    <Form.Group as={Col} controlId="item" onChange={this.handleInputChange}>
                      <Form.Label style={{fontSize: "14px"}}>Item #</Form.Label>
                      {this.state.id ?
                      <Form.Control disabled placeholder="Enter item code" defaultValue={this.state.item} />
                      : <Form.Control placeholder="Enter item code" defaultValue={this.state.item} />
                      }                        
                    </Form.Group>
                   
                  </Form.Row> */}
                  <Form.Row>
                    <Form.Group as={Col} controlId="description" onChange={this.handleInputChange}>
                      <Form.Label style={{fontSize: "14px"}}>Description</Form.Label>
                      <Form.Control required="true" placeholder="Enter item description" defaultValue={this.state.description}></Form.Control>            
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group as={Col} controlId="qty" onChange={this.handleInputChange}>
                      <Form.Label style={{fontSize: "14px"}}>Quantity</Form.Label>
                      <Form.Control required="true" type="Number" placeholder="Enter item quantity" defaultValue={this.state.qty}></Form.Control>            
                    </Form.Group>
                  </Form.Row>
                  {this.state.warehouseloc &&
                    <Form.Row>
                    <Form.Group as={Col} controlId="warehouseloc" onChange={this.handleInputChange}>
                      <Form.Label style={{fontSize: "14px"}}>Warehouse</Form.Label>
                      <Form.Control disabled  defaultValue={this.state.warehouseloc}></Form.Control>            
                    </Form.Group>
                  </Form.Row>
                  }
                  <Form.Row>
                    <Form.Group as={Col} controlId="unitPrice" onChange={this.handleInputChange}>
                      <Form.Label style={{fontSize: "14px"}}>Unit Price</Form.Label>
                      <Form.Control required="true" type="Number" placeholder="Enter unit price" defaultValue={this.state.unitPrice}></Form.Control>            
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group as={Col} controlId="discount" onChange={this.handleInputChange}>
                      <Form.Label style={{fontSize: "14px"}}>Discount</Form.Label>
                      <Form.Control type="Number" placeholder="Enter item discount" defaultValue={this.state.discount}></Form.Control>                        
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group as={Col} controlId="tax01" onChange={this.handleInputChange}>
                      <Form.Label style={{fontSize: "14px"}}>Tax</Form.Label>
                      <Form.Control as="select" defaultValue={this.state.tax01} ref="templateSelect">
                            {txOpt}                            
                      </Form.Control>            
                    </Form.Group>
                   </Form.Row>
                   <div style={{float: "left"}} >                     
                    {/* {this.state.id && 
                      <Button type="submit" variant="outline-primary  mr-3" size="sm" >Update</Button>
                      } */}
                    
                      <Button type="submit" variant="outline-primary  mr-3" size="sm">Save</Button>
                    
                      <Button onClick={this.handleCancel} variant="outline-primary  mr-3" size="sm" >Cancel</Button>
                    </div>
              </Form>
              
          </Card.Body>
          
        </Card>

        <>
                <Modal show={this.state.searchmodal} onHide={this.handleSelectItemClose.bind(this)}
                  
                  size="lg"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header closeButton>              
                    <Modal.Title>Select an inventory item</Modal.Title>              
                  </Modal.Header>
                  <Modal.Body>
                        <ToolkitProvider
                        bootstrap4
                        keyField='uniqueid'
                        data={ this.state.invitems }
                        columns={ this.state.invcolumns }
                        search                        
                      >
                        {
                          props => (
                            <div> 
                                                       
                              <BootstrapTable style={{scrollY: "200px",scrollCollapse: true}}
                                bootstrap4
                                { ...props.baseProps }
                                { ...props.paginationFactory }
                                { ...props.striped }
                                { ...props.defaultEquipSorted }
                                selectRow={ this.state.selectInvRow }
                                //pagination={ paginationFactory( {sizePerPage: 6}) }                     
                                pagination={ paginationFactory({hideSizePerPage: true}) }                     
                                bordered = {false} 
                                condensed = {true}  
                                //defaultSorted = { this.state.defaultSorted } 
                                cellEdit={ cellEditFactory({ mode: 'click', blurToSave: true }) }
                              />
                            </div>
                          )
                        }
                      </ToolkitProvider>

                  </Modal.Body>
                  <Modal.Footer style={{justifyContent: 'left'}}>
                  <div style={{float: "left"}} > 
                    <Button variant="outline-primary mr-3" onClick={this.handleSelectItem.bind(this)}>
                      Select
                    </Button>
                    <Button variant="outline-primary" onClick={this.handleSelectItemClose.bind(this)}>
                      Cancel
                    </Button>                       
                    </div>                 
                  </Modal.Footer>
                </Modal>
                </>

      </div>
    );
  }
}

export default InvoiceAddLineItem;